import { Stack, Typography } from "@mui/material";
import { GoalsFulfillmentSidebarChart } from "Components/Analyses/GoalsFulfillment/GoalsFulfillmentSidebarChart";
import { roundAllocationTo100Percent } from "Components/Analyses/GoalsFulfillment/helpers";
import { HStack } from "Components/_Shared/Core/Stack";
import { useGetAssetAllocationOverview } from "Infrastructure/ApiZfp/AnalyzerApi";
import { Spacing } from "Infrastructure/Themes/Themes";
import { useParams } from "react-router-dom";

export const PdfTemplatePortfolio = () => {
  const { analysisId, versionId } = useParams() as {
    analysisId: string;
    versionId: string;
  };

  const { data: overview } = useGetAssetAllocationOverview(analysisId, versionId);

  if (!overview) return null;

  return (
    <Stack spacing={Spacing.L} width={"100%"}>
      <Typography variant="h2">Rozložení investičního portfolia</Typography>
      <HStack spacing={Spacing.XXL} width="100%" alignItems="stretch">
        <Stack flex={1} minWidth={0}>
          <Typography variant="h6">Stávající řešení</Typography>
          <GoalsFulfillmentSidebarChart allocation={roundAllocationTo100Percent(overview.currentStateDto.assetAllocation)} />
        </Stack>
        <Stack flex={1} minWidth={0}>
          <Typography variant="h6">Navrhované řešení</Typography>
          <GoalsFulfillmentSidebarChart allocation={roundAllocationTo100Percent(overview.proposedStateDto.assetAllocation)} />
        </Stack>
      </HStack>
    </Stack>
  );
};
